import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { KeyEventUtil } from 'utils'

const FechaEmisionFormGroup = ({ iError, iTouched, fIsSubmitting, handleChange, values, setValues }) => {
  const onInputChange = React.useCallback(
    e => {
      handleChange(e)
      const nuevaFecha = e.target.value
      values.fechaEmision = nuevaFecha
      setValues(values)
    },
    [handleChange, values, setValues]
  )

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('productoSelect', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='FEC. EMISION' htmlFor='date-fechaEmision' md={6} alignRightAt='md' />
      <Col md={6}>
        <Field name='fechaEmision'>
          {({ field }) => (
            <Form.InputDate
              {...field}
              id='date-fechaEmision'
              onChange={onInputChange}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaEmisionFormGroup)
